import { css, Theme } from '@emotion/react'

import { FONT_URL } from '@/constants/font'

import { fontSize } from './mixin'

/**
 * Global(전체) style
 * @param theme 글로벌 속성에서 참고할 theme 객체
 */
export default function global(theme: Theme) {
  return css`
    @font-face {
      font-family: TMOBI;
      src:
        url(${FONT_URL.REGULAR.WOFF2}) format('woff2'),
        url(${FONT_URL.REGULAR.WOFF}) format('woff');
      font-weight: 400; // normal
      font-style: normal;
      font-stretch: normal;
      font-display: swap;
    }

    @font-face {
      font-family: TMOBI;
      src:
        url(${FONT_URL.MEDIUM.WOFF2}) format('woff2'),
        url(${FONT_URL.MEDIUM.WOFF}) format('woff');
      font-weight: 500; // medium
      font-style: normal;
      font-stretch: normal;
      font-display: swap;
    }
    @font-face {
      font-family: TMOBI;
      src:
        url(${FONT_URL.BOLD.WOFF2}) format('woff2'),
        url(${FONT_URL.BOLD.WOFF}) format('woff');
      font-weight: 700; // bold
      font-style: normal;
      font-stretch: normal;
      font-display: swap;
    }

    @font-face {
      font-family: TMOBI;
      src:
        url(${FONT_URL.HEAVY.WOFF2}) format('woff2'),
        url(${FONT_URL.HEAVY.WOFF}) format('woff');
      font-weight: 800; // black
      font-style: normal;
      font-stretch: normal;
      font-display: swap;
    }

    :root {
      // font-weight
      --font-weight-normal: 400;
      --font-weight-medium: 500;
      --font-weight-bold: 600;
      --font-weight-black: 900;
    }

    * {
      font-family: TMOBI, 'Noto Sans', 'Roboto', AppleSDGothicNeo, AppleSDGothicNeo-Regular,
        '맑은 고딕', 'Malgun Gothic', '나눔고딕', NanumGothic, '돋움', Dotum, '굴림', Gulim,
        Helvetica, HelveticaNeue, sans-serif;
    }
    html,
    body {
      background: ${theme.background};
      ${fontSize(theme, 16)};
      color: ${theme.text};
      font-weight: var(--font-weight-normal);
      height: 100%;
    }
    body {
      padding-right: constant(safe-area-inset-right);
      padding-left: constant(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
      padding-left: env(safe-area-inset-left);
    }
    #__next {
      position: relative;
      height: 100%;
    }
  `
}
